import { useState, useEffect } from 'react';
import axios from 'axios';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';


interface ServicesProps {
  id: number;
  title: string;
  description: string;
  icon: string;
}

const Services = (): JSX.Element => {
  const theme = useTheme();

  const [services, setServices] = useState<ServicesProps[]>([]);

  const fetchServices = () => {
    axios
      .get<ServicesProps[]>('http://120.46.135.166:8000/services', {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setServices(response.data);
      })
      .catch((error) => console.log(error));
  };

  const navigate = useNavigate();

  const handleCardClick = (id: string | number) => {
    window.open(`/services/${id}`); // 假设每个服务都有唯一的 id
  };
  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <div id='services'>
      <Box
        sx={{
          paddingTop: 5,
          paddingBottom: 10,
          paddingX: 2,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box marginBottom={4}>
          <Typography
            variant='h5'
            align='center'
            fontWeight={700}
            marginTop={theme.spacing(1)}
            gutterBottom
            sx={{
              color: theme.palette.text.primary,
              textTransform: 'uppercase',
            }}
          >
            志向新闻
          </Typography>
          <Typography
            variant='subtitle1'
            align='center'
            marginTop={theme.spacing(1)}
            gutterBottom
            color={theme.palette.text.secondary}
          >
            新闻新闻新闻
          </Typography>
        </Box>
        <Container>
          <Grid container spacing={4}>
            {services.map((item, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <Box component={Card} padding={4} width={1} height={1} onClick={() => handleCardClick(item.id)}
sx={{ cursor: 'pointer' }} >
                  <Box display='flex' flexDirection='column'>
                    <Box
                      component={Avatar}
                      width={50}
                      height={50}
                      marginBottom={2}
                      bgcolor={
                        theme.palette.mode === 'dark'
                          ? theme.palette.primary.main
                          : theme.palette.success.dark
                      }
                      color={theme.palette.background.paper}
                    >
                      <Icon className='material-icons-outlined'>
                        {item.icon}
                      </Icon>
                    </Box>
                    <Typography
                      variant='h6'
                      gutterBottom
                      sx={{ fontWeight: 500 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography color={theme.palette.text.secondary}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

export default Services;
